import * as React from 'react';
import { LngLatBounds } from 'mapbox-gl';

import { AuthContext } from '../../AuthContext';
import { Station, StationFactory } from '../../resource/'; 
import { Query } from '../../services/';
import { MapStationsPopup } from './MapStationsPopup';
import { IMapElement } from '../../maps/ClusteredMap/IMapElement';
import { ClusteredMap } from '../../maps/ClusteredMap/ClusteredMap';
import { MapboxMap } from 'react-map-gl';
import { Loader } from '@independent-software/typeui/controls/Loader';

interface IProps {
  query: Query;
  onClick: (station: Station) => void;
  time: number;
}

const MapStations = (props: IProps) => {
  const mapRef = React.useRef<MapboxMap>(null);
  const auth = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(true);
  const [elements, setElements] = React.useState([] as IMapElement[]);
  const [initial, setInitial] = React.useState(true);

  const loadStations = (bounds: LngLatBounds, zoom: number) => {
    StationFactory.getMap(auth, props.query, bounds, zoom)
    .then((response: IMapElement[]) => {
      setElements(response);
      setLoading(false);
      if(initial && response.length > 0) {
        setInitial(false);
        let west = Math.min(...response.map(e => e.longitude));
        let east = Math.max(...response.map(e => e.longitude));
        let north = Math.max(...response.map(e => e.latitude));
        let south = Math.min(...response.map(e => e.latitude));
        mapRef.current.fitBounds(
          new LngLatBounds([ west, south, east, north ]), {
            maxZoom: 12,
            padding: {top: 100, bottom:100, left: 100, right: 100},
            animate: false
          }
        );
      }
    });
  }

  const handleChange = (bounds: LngLatBounds, zoom: number) => {
    loadStations(bounds, zoom);
  }

  const handleLoad = (map: MapboxMap) => {
    mapRef.current = map;
  }

  return (
    <>
      {loading && <Loader/>}
      <ClusteredMap
        time={props.time}
        onChange={handleChange}
        onLoad={handleLoad}
        elements={elements}
        popup={(item:Station) => <MapStationsPopup station={item} onClick={props.onClick}/>}
      />
    </>
  );
}

export { MapStations }
